import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ListUsersRole, ListUsersStatus } from '@/entities/tenantusers/api/generated/model';
import { UserListPage } from '@/pages/users/ui/UserListPage';
import { paginationSchema, routeValidateQuerySearch } from '@/shared/lib/route';

// URLクエリパラメータのスキーマ
const usersSearchSchema = paginationSchema.extend({
  keyword: z.string().optional(),
  role: z.nativeEnum(ListUsersRole).optional(),
  status: z.nativeEnum(ListUsersStatus).optional(),
});

export const Route = createFileRoute('/_protected/users/')({
  component: UserListPage,
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: true,
      withPaginationSchema: usersSearchSchema,
      defaultValues: undefined,
    }),
});
